<template>
  <div class="-checkbox-box">
    <wt-check-box
      @changed="changed"
      :checked="checkboxChecked"
      :disabled="checkboxDisabled"
      :label-right="checkboxLabel"
    ></wt-check-box>
  </div>
</template>

<script>
import propsMixin from '../mixins/propsMixin.vue';

export default {
  mixins: [propsMixin],

  mounted() {
    this.changed(this.checkboxChecked);
  },

  methods: {
    changed(isChecked) {
      this.$emit('update:checkbox', isChecked);
    },
  },
};
</script>
